import { useAtomValue } from "jotai";
import { useEffect, useRef, useTransition } from "react";
import { useQueryLoader } from "react-relay";

import { sessionAtom } from "../../../features/Session";
import { ClubNavigator } from "../../../navigators/ClubNavigator";
import { ClubNavigatorQueryString } from "../../../navigators/ClubNavigator/ClubNavigator";
import { ClubNavigatorQuery } from "../../../navigators/ClubNavigator/__generated__/ClubNavigatorQuery.graphql";

export const ClubQuerier = ({ clubSlug }: { clubSlug: string }) => {
  const authenticatedUserId = useAtomValue(sessionAtom)?.user.id ?? null;
  const previousAuthenticatedUserIdRef = useRef(authenticatedUserId);
  const [, startTransition] = useTransition();
  const [queryRef, loadQuery] = useQueryLoader<ClubNavigatorQuery>(
    ClubNavigatorQueryString
  );

  useEffect(() => {
    loadQuery({ clubSlug: clubSlug }, { fetchPolicy: "network-only" });
  }, [loadQuery, clubSlug]);

  useEffect(() => {
    const previousAuthenticatedUserId = previousAuthenticatedUserIdRef.current;
    previousAuthenticatedUserIdRef.current = authenticatedUserId;

    if (previousAuthenticatedUserId || !authenticatedUserId) {
      return;
    }

    // Keep the login route rendered while Relay prepares the authenticated
    // query, then commit the new query reference and navigator together.
    startTransition(() => {
      loadQuery({ clubSlug }, { fetchPolicy: "network-only" });
    });
  }, [authenticatedUserId, clubSlug, loadQuery, startTransition]);

  return queryRef ? <ClubNavigator clubRef={queryRef} /> : null;
};
